/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cm-upload-button-box[_ngcontent-%COMP%]{padding:1.125rem .5rem;font-size:14px}.cm-upload-button-box.drag-over[_ngcontent-%COMP%]{background:#abb4f8}.filelist-file-name[_ngcontent-%COMP%]{-webkit-box-flex:1;flex:1;overflow:hidden;text-overflow:ellipsis}.remove-btn[_ngcontent-%COMP%]{color:red;margin-left:10px;cursor:pointer}"];
export { styles as styles };
